// src/context/textbookApi.js
import { api } from "./api";

/**
 * Darsliklar uchun RTK Query endpointlari
 */
export const textbookApi = api.injectEndpoints({
  endpoints: (builder) => ({
    // Darslik yaratish (PDF + mavzular)
    createTextbook: builder.mutation({
      // TextbookCreate.jsx dan FormData keladi
      query: (formData) => ({
        url: "/textbooks",          // backend: POST /api/textbooks
        method: "POST",
        body: formData,             // FormData – header qo‘shmaymiz!
      }),
      invalidatesTags: ["Textbook"],
    }),

    // Darsliklar ro‘yxati
    getTextbooks: builder.query({
      query: () => ({
        url: "/textbooks",          // GET /api/textbooks
        method: "GET",
      }),
      providesTags: ["Textbook"],
    }),

    // Bitta darslik + mavzulari
    getTextbookById: builder.query({
      query: (id) => ({
        url: `/textbooks/${id}`,    // GET /api/textbooks/:id
        method: "GET",
      }),
      providesTags: (_res, _err, id) => [{ type: "Textbook", id }],
    }),
  }),
  overrideExisting: false,
});

// Hooklar
export const {
  useCreateTextbookMutation,
  useGetTextbooksQuery,
  useGetTextbookByIdQuery,
} = textbookApi;
